import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

import styles from './Select.css';
import { Backdrop } from './..';

class Select extends Component {
  state = { hover: false }

  handleToggleHover = () => {
    const { hover } = this.state;

    return this.setState({ hover: !hover });
  }

  render() {
    const { options, active = options[0], onClick, placeholder, isMobile } = this.props;
    const { hover } = this.state;

    return (
      <div className={styles.Wrapper}>
        <div
          onMouseEnter={!isMobile ? this.handleToggleHover : undefined}
          onMouseLeave={!isMobile ? this.handleToggleHover : undefined}
          className={[styles.Select, !hover ? undefined : styles.Hover].join(' ')}
        >
          <div
            onClick={e => {
              e.stopPropagation();

              return !isMobile ? undefined : this.handleToggleHover();
            }}
            onKeyPress={undefined}
            role="button"
            tabIndex="0"
            className={styles.Preview}
          >
            {active !== null ? active : placeholder}
          </div>
          <div className={styles.List}>
            <ul>
              {
                options
                  .map(item => (
                    <li
                      key={v4()}
                      onClick={() => onClick(item)}
                      onKeyPress={undefined}
                      role="button"
                      tabIndex="0"
                    >
                      {item || placeholder}
                    </li>
                  ))
              }
            </ul>
          </div>
        </div>
        {
          !isMobile ?
            undefined :
            <Backdrop
              show={hover}
              onClick={this.handleToggleHover}
              transparent
            />
        }
      </div>
    );
  }
}

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  isMobile: PropTypes.bool
};

Select.defaultProps = {
  active: undefined,
  onClick: () => undefined,
  placeholder: 'Select one',
  isMobile: false
};

export { Select };



// WEBPACK FOOTER //
// ./src/components/common/Select/Select.js